import vSelect from "vue-select";

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},

	components: {
		"v-select": vSelect,
	},

	mounted() {

	},

	data() {
		return {

		};
	},

	computed: {
		selectedOptions: {
			get() {
				return this.$refs.select ? this.$refs.select.selectedValue : [];
			}
		}
	},

	methods: {
		handleInput(value) {
			if (this.context.node && typeof this.context.node.input === 'function') {
				this.context.node.input(value);
			} else if (this.context.handlers && typeof this.context.handlers.input === 'function') {
				this.context.handlers.input(value);
			}
		},
		onClose: function () {
			if (this.context.handlers?.blur) {
				this.context.handlers.blur();
			} else if (this.context.blurHandler) {
				this.context.blurHandler();
			}
		},

		onOptionClick(option) {
			this.context.model.splice(this.context.model.indexOf(option.uuid), 1);
		},

		onSearch: function(val, loading) {
			if(val.length) {
				loading(true)
				this.$emit('search', {loading, val});
			} else {
				loading(false)
				let emptyArray = []
				this.$emit('search', {loading, emptyArray})
			}
		}
	},
};
